<template>
	<div v-html="apply">
      {{apply}}
  </div>
</template>
<script>
export default {
    name:"applyText",
    data(){
        return {
            apply:''
         }
    },
   	created(){
      this.get()
    },
    methods:{
      get(){
        const router = this.$route.query.htmls
        this.apply = router
        this.$nextTick(()=> {
               document.forms [0].submit()
       	 })
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/zhifubao.vue